import check from 'assets/subscription/check.svg';
import SubscribeButtons from 'components/altus-plus/subscribe-buttons';
import SubscriptionBackHeader from 'components/altus-plus/subscription-back-header';
import Flex from 'components/flex/flex';
import { useStatusBarHeight } from 'hooks/use-status-bar-height';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { SegmentEventType, track } from 'segment';
import styles from './subscription.module.scss';

const POINTS: {
  title: string;
  text: string;
}[] = [
  {
    title: "Travail d'abord, plaisir ensuite",
    // text: `Votre enfant devient acteur de son apprentissage en sélectionnant les chapitre qu'il voit en cours`,
    text: `Votre enfant gagne du temps d’écran avec des quiz éducatifs.`,
  },
  {
    title: 'CM1 à la Terminale',
    text: 'Un catalogue de 100k exercices alignés avec l’Éducation Nationale.',
  },
];

export default function SubscriptionInitial() {
  const statusBarHeight = useStatusBarHeight();
  const navigate = useNavigate();
  const points = useMemo(() => {
    const indexes = [Math.floor(Math.random() * POINTS.length)];

    while (indexes.length < 2) {
      const newIndex = Math.floor(Math.random() * POINTS.length);
      if (newIndex !== indexes[0]) indexes.push(newIndex);
    }
    return indexes.map((i) => POINTS[i]);
  }, []);

  return (
    <div className={styles.background} style={{ paddingTop: statusBarHeight }}>
      <SubscriptionBackHeader
        onBack={() => {
          navigate(-1);
          track(SegmentEventType.EXIT_PAYMENT_FLOW);
        }}
      />
      <Flex
        direction="column"
        align="center"
        width="100%"
        height="100%"
        pad="20px"
        justify="space-between"
        style={{
          paddingTop: 0,
        }}
      >
        <img src="/altus-stars.svg" alt="Altus" className={styles.altusStars} />
        <div className={styles.subscriptionText}>
          <b>2.9x</b> plus d’impact
          <br />
          avec Altus <span className={styles.altusPlus}> Plus</span>
        </div>
        <div className={styles.roundedBox}>
          {points.map((point) => (
            <div className={styles.point} key={point.title}>
              <div className={styles.icon}>
                <img src={check} alt="Check" className={styles.icon} />
              </div>
              <div className={styles.text}>
                <div className={styles.title}>{point.title}</div>
                <div className={styles.description}>{point.text}</div>
              </div>
            </div>
          ))}
        </div>
        <SubscribeButtons
          backAmount={-1}
          trackingEvent={SegmentEventType.PAYMENT_ARGUMENTS_INITIAL}
          trackingProperties={{
            point1: points[0],
            point2: points[1],
          }}
          nextHref="/subscribe/arguments/3"
          nextText="ESSAYER GRATUITEMENT"
          backDisabledOnLoad
        />
      </Flex>
    </div>
  );
}
